import React from "react";

const pageContent = {
    editAI: {
        title: "Edit AI",
        videoSrc: "https://assets-editai.azureedge.net/videos-demos/editai-marketer-suite-features.mp4",
        thumbnailSrc: {
            light: "https://startup-template-sage.vercel.app/hero-light.png",
            dark: "https://startup-template-sage.vercel.app/hero-dark.png"
        }
    }
};

export default function DemoSection() {
    return (
        <div className="max-w-4xl mx-auto md:px-0 mt-4 md:mt-0 mb-8 md:mb-16">
            <div className="flex flex-col space-y-4 sm:space-y-6 md:space-y-8 items-center">
                <div className="w-full max-w-[90vw] sm:max-w-[80vw] md:max-w-[70vw] lg:max-w-full relative">
                <video autoPlay loop muted playsInline>
                        <source src={pageContent.editAI.videoSrc} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
        </div>
    )
};